// receivableDetail.slice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ReceivableDetailState {
  /**
   * 📌 Detalle actual cargado
   */
  detail: any | null;

  /**
   * 🆔 ID seleccionado para ver detalle
   */
  selectedReceivableId: number | null;

  /**
   * 🪟 Estado del modal
   */
  isModalOpen: boolean;

  /**
   * 🔄 loading general
   */
  loading: boolean;

  /**
   * ❌ error global
   */
  error: string | null;
}

const initialState: ReceivableDetailState = {
  detail: null,

  selectedReceivableId: null,
  isModalOpen: false,

  loading: false,
  error: null,
};

const receivableDetailSlice = createSlice({
  name: "receivableDetail",
  initialState,
  reducers: {
    /**
     * 🔄 loading
     */
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    /**
     * ❌ error
     */
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    /**
     * 📌 set detail
     */
    setReceivableDetail(state, action: PayloadAction<any>) {
      state.detail = action.payload;
      state.loading = false;
    },

    /**
     * 🪟 abrir modal
     */
    openDetailModal(
      state,
      action: PayloadAction<number>
    ) {
      state.selectedReceivableId = action.payload;
      state.isModalOpen = true;
    },

    /**
     * ❌ cerrar modal
     */
    closeDetailModal(state) {
      state.isModalOpen = false;
    },

    /**
     * 🧹 limpiar detalle completo
     */
    clearReceivableDetail(state) {
      state.detail = null;
      state.selectedReceivableId = null;
      state.isModalOpen = false;
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setError,
  setReceivableDetail,
  openDetailModal,
  closeDetailModal,
  clearReceivableDetail,
} = receivableDetailSlice.actions;

export default receivableDetailSlice.reducer;